<template>
  <!-- <modal
    name="popup"
    classes="v--modal vue-dialog"
    height="auto"
    :width="null"
    :pivotX="0"
  > -->
  <div
    class="
      flex flex-col
      space-y-4
      min-w-screen
      h-screen
      animated
      fadeIn
      faster
      fixed
      left-0
      top-0
      justify-center
      items-center
      inset-0
      z-50
      outline-none
      focus:outline-none
    "
  >
    <div
      class="
        flex flex-col
        xxs:p-8
        p-2
        2md:w-108
        sm:w-98
        
        
        bg-gray-50
        shadow-md
        hover:shodow-lg
        rounded-xl border border-gray-300
        
      "
    >
      <button @click="handleModal" class="hover:bg-transparent bg-transparent xxs:-mt-4">
          <img src="@/assets/images/croix.svg" class="w-5 float-right" alt="" />
      </button>
      <div class="flex items-center justify-between">
        <div class="dialog-content">
          <div class="dialog-c-title flex flex-row items-center justify-center 2md:mb-6 mb-4">
            <img src="@/assets/images/logo_Index_acta.png" class="2md:w-32 mr-5 xxs:w-20 w-10" />
            <p class="2md:text-lg text-xs xxs:mb-3 xxs:mt-4">Bienvenue sur le site Index Acta</p>
          </div>
          <div class="dialog-c-text">
            <p class="2md:text-lg text-xs text-center 2md:mb-6 xxs:mb-4">
              Consultez les informations
              <span class="bold orange">mises à jour en temps réel</span> sur
              les produits commercialisés en France,
              <span class="bold">phytopharmaceutiques, macro-organismes,</span>
              produits utilisables en
              <span class="vert bold" style="color: #a8c30f"
                >agriculture biologique, biocontrôle</span
              ><span class="bold">, biocides agricoles… </span>
            </p>
            <ul class="liste-fleche 2md:text-lg text-xs">
              <li>Plus de <span class="bold orange">4000 solutions</span></li>
              <li>
                Des<span class="bold orange">
                  informations complètes et fiables</span
                >
              </li>
              <li>
                Un<span class="bold orange">
                  moteur de recherche performant</span
                >
              </li>
              <li>
                Un<span class="bold orange">
                  décryptage des actualités règlementaires</span
                >
              </li>
              <li>
                Une<span class="bold orange">
                  mise en favori de vos recherches</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="text-center 2md:mt-7 mt-2 mb-4">
        <input
          type="checkbox"
          id="check"
          value="accepted"
          @click="getCheckedResult"
        />
        <label class="2md:text-lg text-xs" for="check" 
          >Je ne souhaite plus afficher ce message lors de mes prochaines
          navigations</label
        >
      </div>
      <div class="dialog-buttons flex 2md:mt-4 items-center justify-center ">
        <button @click="handleModal" class="bg-gray-200 py-2 px-9 bold mr-3">Annuler</button>
        <button @click="setModal" class="bg-orange py-2 px-9 bold hover:bg-orange text-white">Valider</button>
      </div>
    </div>
  </div>
  <!-- </modal> -->
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Popup",

  data() {
    return {
      isChecked: false,
    };
  },
  methods: {
    ...mapActions({
      handleModal: "popup/setPopup",
      setShouldPopupOpens: "popup/setShouldPopupOpens"
    }),
    getCheckedResult(e) {
      if (e.target.checked) {
        this.isChecked = true;
      }
    },
    setModal() {
      this.handleModal();
      if (this.isChecked) {
        this.setShouldPopupOpens(false)
      }
    },
  },
};
</script>
